import { AppSettings } from "../Constants/AppSettings"
// import { controllers } from "../Controllers/Controller"
import { baseResponse } from "../DataTypes/baseResponse"

const noInternetConnectionError:baseResponse = {
    data: [],
    status: false,
    statusCode: 0,
    statusMessage: 'The same internet connection error'
}

const duringParsingError:baseResponse = {
    data: [],
    status: false,
    statusCode: 1,
    statusMessage: 'Error during parsing json response'
}

export const fetchData = async (
    url = '',
    type = 'POST',
    body = {},
    isAborted = false
) => {
    try{
        // console.log('BODY', JSON.stringify(body))
        // const startTime = new Date().getTime();
        // console.log('sendURL', `${AppSettings.endpoint}/${url}`);
        var bodySend = {}
        if(type !== "GET"){
            // @ts-ignore
            bodySend.body = JSON.stringify(body)
        }
        const response = await fetch(
            `${AppSettings.endpoint}/${url}`,
            {
                method: type,
                headers: {
                //   'Content-Type': 'text/plain',
                  'Content-Type': 'application/json',
                },
                ...bodySend
            }
        )
        if (response.ok) {
            try{
                const json = await response.text();
                return JSON.parse(json);
            } catch(e){
                return duringParsingError
            }
        } else {
            console.log('!OK')
            return response
        }
    } catch(e){
        console.log('error', e)
        return noInternetConnectionError
        // throw e
    }
}

